module.exports = __webpack_public_path__ + "71216da39e18f8b4266afe9c70316b5a.jpg";